var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sign",staticClass:"tk-sign"},[_c('canvas',{ref:"signCanvas",attrs:{"id":"","width":_vm.width,"height":_vm.height},on:{"touchend":_vm.touchend,"touchstart":_vm.touchstart,"touchmove":_vm.touchmove}})])}
var staticRenderFns = []

export { render, staticRenderFns }